import { baseApi } from "./apiConfig.js";
import axios from "axios";

let cancelToken;
let cancelTokenSRP;
export const getSRP = async (url) => {
  try {
    if (typeof cancelTokenSRP != typeof undefined) {
      cancelTokenSRP.cancel("Operation canceled due to new request.");
    }
    cancelTokenSRP = axios.CancelToken.source();
    let response;
    if (url.includes("auctions") && url.includes("eventId=")) {
      response = await baseApi.get(`${url}&rect=true`, { cancelToken: cancelTokenSRP.token });
    } else if (
      url.includes("auctions") || 
      url.includes("near-me") || 
      url.includes("near-by") || 
      url.includes("bank-owned") || 
      url.includes("auctions/condos") || 
      url.includes("foreclosures") || 
      url.includes("auctions/land") || 
      url.includes("short-sale") || 
      url.includes("non-bank-owned")
    ) {
      response = await baseApi.get(`/portal${url}`, { cancelToken: cancelTokenSRP.token });
    } else {
      response = await baseApi.get(`/portal/auctions?${url}`, { cancelToken: cancelTokenSRP.token });
    }
    const { status, data } = response;
    if (status === 200) {
      return data.data;
    } else {
      throw response;
    }
  } catch (error) {
    if (error.code !== "ERR_CANCELED") {
      console.error("SRP error", error);
    }
  }
};
export const getSRPMap = async (url) => {
  try {
    let response;
    if (!url.includes('&rect=true')) {
      url = url + '&rect=true';
    }
    if (url.includes("auctions") && url.includes("eventId=")) {
      response = await baseApi.get(`${url}&rect=true&viewType=map`);
    } else if (
      url.includes("auctions") || 
      url.includes("near-me") || 
      url.includes("near-by") || 
      url.includes("bank-owned") || 
      url.includes("auctions/condos") || 
      url.includes("foreclosures") || 
      url.includes("auctions/land") || 
      url.includes("short-sale") || 
      url.includes("non-bank-owned")) {
      response = await baseApi.get(`/portal${url}&viewType=map`);
    } else {
      response = await baseApi.get(`/portal/auctions?${url}&viewType=map`);
    }
    const { status, data } = response;
    if (status === 200) {
      return data.data;
    } else {
      throw response;
    }
  } catch (error) {
    console.error("SRP Map error", error);
  }
};

export const getDisabledFilters = async (url) => {
  try {
    const response = await baseApi.get(`/portal/getDisabledFilters?${url}`);
    const { status, data } = response;
    if (status === 200) {
      return data.data;
    } else {
      throw response;
    }
  } catch (error) {
    console.error("getDisabledFilters error", error);
  }
};

export const getPropertyImages = async (propertyId) => {
  try {
    const response = await baseApi.get(`/portal/api/getPropertyImages/${propertyId}`);
    const { status, data } = response;
    if (status === 200) {
      return data.data;
    } else {
      throw response;
    }
  } catch (error) {
    console.error("getPropertyImages error", error);
  }
};

export const getCampaignDetails = async ({campaignId, url}) => {
  try {
    const response = await baseApi.get(`/portal/getCampaignDetailsById/${campaignId}?${url}`);
    const { status, data } = response;
    if (status === 200) {
      return data?.data;
    } else {
      throw response;
    }
  } catch (error) {
    console.error("getCampaignDetails error", error);
  }
};

export const getAutocompleteSuggestions = async (query, category = "ALL") => {
  try {
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    cancelToken = axios.CancelToken.source();
    
    let apiParams = `query=${encodeURIComponent(query)}`;
    
    // Determine API parameters based on category
    if (category && category !== "Browse All") {
      if (category.includes("Bank") || category.includes("Owned")) {
        apiParams += "&prop_cat=1";
      } else if (category.includes("Signature")) {
        apiParams += "&seller_code=signature-seller";
      } else if (category.includes("Off Market")) {
        apiParams += "&seller_code=offmarket-properties";
      } else if (category.includes("Commercial")) {
        apiParams += "&prop_cat=8";
      } else if (category.includes("Foreclosure")) {
        apiParams += "&prop_cat=4";
      } else if (category.includes("Short")) {
        apiParams += "&prop_cat=5";
      } else if (category.includes("Traditional")) {
        apiParams += "&list_type=AUCN";
      }
    }
    
    const response = await baseApi.get(
      `/portal/v2.0/didyoumean?${apiParams}`,
      { cancelToken: cancelToken.token }
    );
    const { status, data } = response;
    if (status === 200) {
      return data;
    }
    return response;
  } catch (error) {
    if (error.code !== "ERR_CANCELED") {
      console.error("SRP Search error", error);
    }
  }
};
